<div class="archiv">
  <p class="halvany">
    A digitális bizonyítványt a tanuló jogviszonyának megszűnésétől <b>80 évig</b> elérhetővé kell tenni; ha az
    intézmény jogutód nélkül szűnik meg, archív hozzáféréssel (Nkt. 57. § (9a)–(9b)). Az átadási csomag az intézmény
    összes érvényes digitális bizonyítványát tartalmazza a nyilvántartással (tanuló, oktatási azonosító, tanév,
    dokumentum-azonosító, aláírás és időbélyeg állapota) és ellenőrző összegekkel – ezt veheti át a fenntartó, a
    jogutód vagy a levéltár. A volt tanulók a saját fiókjukkal (Dokumentumaim) továbbra is elérik a bizonyítványukat.
  </p>

  <div *ngIf="betolt" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

  <!-- 1. Átadási csomag -->
  <h3 class="resz-cim"><ion-icon name="archive-outline"></ion-icon> Átadási csomag</h3>
  <ion-note color="warning" *ngIf="!betolt && jegyzekHiba" class="blokk">{{ jegyzekHiba }}</ion-note>
  <ng-container *ngIf="jegyzek">
    <ion-item lines="full">
      <ion-label class="ion-text-wrap">
        <h2>{{ jegyzek.intezmeny?.nev || intezmeny }}</h2>
        <p>
          <b>{{ jegyzek.darab }}</b> érvényes digitális bizonyítvány
          <ng-container *ngFor="let t of tanevek"> · {{ t.tanev }}: {{ t.db }}</ng-container>
        </p>
        <p>A ZIP tartalma: a PDF-ek tanévenként, <i>jegyzek.csv</i>, <i>jegyzek.json</i>, <i>SHA256SUMS.txt</i>, <i>OLVASSEL.txt</i>.</p>
      </ion-label>
      <ion-button slot="end" color="success" (click)="csomag(intezmeny)" [disabled]="csomagKeszul[intezmeny] || !jegyzek.darab">
        <ion-icon slot="start" name="download-outline"></ion-icon>{{ csomagKeszul[intezmeny] ? 'Készül…' : 'Csomag letöltése' }}
      </ion-button>
    </ion-item>

    <ng-container *ngIf="jegyzek.naplo?.length">
      <div class="kis-cim">Korábbi átadások</div>
      <ion-item *ngFor="let n of jegyzek.naplo" lines="none" class="naplo-sor">
        <ion-label class="ion-text-wrap">
          <p>
            {{ n.letrehozva | date: 'yyyy.MM.dd. HH:mm' }} · {{ n.keszitette || '—' }}
            <ng-container *ngIf="n.hozzaferes_mod === 'jogutod'"> (jogutódi hozzáféréssel)</ng-container>
            · {{ n.darab }} dokumentum<ng-container *ngIf="n.hibas">, {{ n.hibas }} hiányzó fájl</ng-container>
          </p>
          <p class="hash" *ngIf="n.zip_sha256">SHA-256: {{ n.zip_sha256 }}</p>
        </ion-label>
      </ion-item>
    </ng-container>
  </ng-container>

  <!-- 2. Jogutódi / fenntartói hozzáférés -->
  <h3 class="resz-cim"><ion-icon name="key-outline"></ion-icon> Archív hozzáférés a fenntartónak / jogutódnak</h3>
  <p class="halvany">
    A felvett belépés (felhasználónév vagy e-mail cím) a meglévő fiókjával – akkor is, ha nem munkatársa az
    intézménynek – letöltheti az átadási csomagot és a jegyzéket. Más adathoz nem kap hozzáférést.
  </p>
  <ion-note color="warning" *ngIf="!betolt && jogosultHiba" class="blokk">{{ jogosultHiba }}</ion-note>
  <ng-container *ngIf="!jogosultHiba">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12" size-md="4">
          <ion-input label="Belépési név vagy e-mail" label-placement="stacked" fill="outline"
            [(ngModel)]="uj.felhasznalo" placeholder="pl. archiv@fenntarto.hu"></ion-input>
        </ion-col>
        <ion-col size="12" size-md="3">
          <ion-input label="Megnevezés" label-placement="stacked" fill="outline"
            [(ngModel)]="uj.megnevezes" placeholder="pl. Fenntartó Alapítvány"></ion-input>
        </ion-col>
        <ion-col size="6" size-md="2">
          <ion-select label="Szerep" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="uj.szerep">
            <ion-select-option *ngFor="let s of szerepek" [value]="s.ertek">{{ s.nev }}</ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col size="6" size-md="3">
          <ion-input label="Jogalap / ügyirat (nem kötelező)" label-placement="stacked" fill="outline"
            [(ngModel)]="uj.jogalap" placeholder="pl. megszüntető okirat száma"></ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-end">
          <ion-button (click)="jogotAd()" [disabled]="mentes || !uj.felhasznalo.trim()">
            <ion-icon slot="start" name="person-add-outline"></ion-icon>Hozzáférés megadása
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list lines="full">
      <ion-item *ngFor="let j of jogosultak" [class.visszavont]="j.visszavonva">
        <ion-label class="ion-text-wrap">
          <h3>{{ j.megnevezes || j.felhasznalo }} <span class="szerep">{{ szerepNev(j.szerep) }}</span></h3>
          <p>{{ j.felhasznalo }}<ng-container *ngIf="j.jogalap"> · {{ j.jogalap }}</ng-container></p>
          <p>
            Megadta: {{ j.letrehozta || '—' }}, {{ j.letrehozva | date: 'yyyy.MM.dd.' }}
            <ng-container *ngIf="j.visszavonva"> · visszavonta: {{ j.visszavonta || '—' }}, {{ j.visszavonva | date: 'yyyy.MM.dd.' }}</ng-container>
          </p>
        </ion-label>
        <ion-badge slot="end" color="medium" *ngIf="j.visszavonva">Visszavonva</ion-badge>
        <ion-button slot="end" fill="outline" color="danger" size="small" *ngIf="!j.visszavonva" (click)="visszavon(j)">
          Visszavonás
        </ion-button>
      </ion-item>
      <ion-note color="medium" *ngIf="!jogosultak.length" class="blokk">Még senkinek nincs archív hozzáférése.</ion-note>
    </ion-list>
  </ng-container>

  <!-- 3. Átvett archívumok (jogutódként) -->
  <ng-container *ngIf="idegen.length">
    <h3 class="resz-cim"><ion-icon name="business-outline"></ion-icon> Átvett intézményi archívumok</h3>
    <p class="halvany">Ezeknek az intézményeknek az archívumához jogutódi / fenntartói hozzáférésed van.</p>
    <ion-item *ngFor="let x of idegen" lines="full">
      <ion-label class="ion-text-wrap">
        <h3>{{ x.intezmeny_nev || x.intezmeny }}</h3>
        <p>{{ x.intezmeny }} · {{ szerepNev(x.szerep) }}<ng-container *ngIf="x.megnevezes"> ({{ x.megnevezes }})</ng-container></p>
      </ion-label>
      <ion-button slot="end" fill="outline" (click)="csomag(x.intezmeny)" [disabled]="csomagKeszul[x.intezmeny]">
        <ion-icon slot="start" name="download-outline"></ion-icon>{{ csomagKeszul[x.intezmeny] ? 'Készül…' : 'Csomag letöltése' }}
      </ion-button>
    </ion-item>
  </ng-container>
</div>
